module.exports = __webpack_public_path__ + "img/icons8-chrysler.38fc725a.svg";